// サイドバー幅の単一の正。Layout.tsx のメインコンテンツ余白と、固定フッターの left オフセット
// （ProductsPage.tsx 等の position:fixed フッター）の二重管理を避けるための共有定数
// （W23 商品一覧UI再設計 設計書 docs/designs/w23-products-ui-redesign.md §3.4 SHOULD-8）。
export const SIDEBAR_WIDTH_PX = 200;
